export default __webpack_public_path__ + "static/media/photo-2-light.58fbbda0.jpg";